import { FilterModalConfig } from "@/types/filters";

export const PRODUCT_FILTER_CONFIG: FilterModalConfig = {
  title: "Filter Products",
  sections: [
    {
      title: "General Filters",
      color: "bg-blue-500",
      fields: [
        {
          key: "title",
          label: "Product Title",
          type: "string",
          placeholder: "Search by product title",
        },
        {
          key: "status",
          label: "Product Status",
          type: "select",
          options: [
            { value: "ACTIVE", label: "Active" },
            { value: "DRAFT", label: "Draft" },
            { value: "ARCHIVED", label: "Archived" },
          ],
        },
        {
          key: "collection_name",
          label: "Collection",
          type: "string",
          placeholder: "Search by collection name",
        },
      ],
    },
    {
      title: "Pricing",
      color: "bg-green-500",
      fields: [
        {
          key: "min_price",
          label: "Minimum Price",
          type: "number",
          placeholder: "₹0",
        },
        {
          key: "max_price",
          label: "Maximum Price",
          type: "number",
          placeholder: "₹10,000",
        },
      ],
    },
    {
      title: "Organization",
      color: "bg-orange-500",
      fields: [
        {
          key: "tag",
          label: "Product Tag",
          type: "string",
          placeholder: "Search by tag",
        },
      ],
    },
    {
      title: "Date Range",
      color: "bg-purple-500",
      fields: [
        {
          key: "created_after",
          label: "Created After",
          type: "date",
        },
        {
          key: "created_before",
          label: "Created Before",
          type: "date",
        },
      ],
    },
  ],
};

export const COUPON_FILTER_CONFIG: FilterModalConfig = {
  title: "Filter Coupons",
  sections: [
    {
      title: "Basic Information",
      color: "bg-blue-500",
      fields: [
        {
          key: "title",
          label: "Coupon Title",
          type: "string",
          placeholder: "Search by title",
        },
        {
          key: "discount_code",
          label: "Discount Code",
          type: "string",
          placeholder: "Search by code",
        },
        {
          key: "type",
          label: "Coupon Type",
          type: "select",
          options: [
            { value: "AmountOffOrder", label: "Amount Off Order" },
            { value: "AmountOffProduct", label: "Amount Off Products" },
            { value: "BuyXGetY", label: "Buy X Get Y" },
            { value: "FreeShipping", label: "Free Shipping" },
          ],
        },
      ],
    },
    {
      title: "Discount Configuration",
      color: "bg-green-500",
      fields: [
        {
          key: "discount_type",
          label: "Discount Type",
          type: "select",
          options: [
            { value: "percentage", label: "Percentage" },
            { value: "fixed", label: "Fixed Amount" },
          ],
        },
        {
          key: "min_discount_value",
          label: "Min Discount Value",
          type: "number",
          placeholder: "Minimum discount value",
        },
        {
          key: "max_discount_value",
          label: "Max Discount Value",
          type: "number",
          placeholder: "Maximum discount value",
        },
      ],
    },
    {
      title: "Status & Settings",
      color: "bg-orange-500",
      fields: [
        {
          key: "enabled",
          label: "Enabled Status",
          type: "boolean",
        },
        {
          key: "automatic",
          label: "Automatic Discount",
          type: "boolean",
        },
        {
          key: "automatic_add_to_cart",
          label: "Auto Add to Cart",
          type: "boolean",
        },
      ],
    },
    {
      title: "Purchase Requirements",
      color: "bg-red-500",
      fields: [
        {
          key: "minimum_purchase_type",
          label: "Purchase Requirement",
          type: "select",
          options: [
            { value: "nothing", label: "No Minimum" },
            { value: "amount", label: "Minimum Amount" },
            { value: "quantity", label: "Minimum Quantity" },
          ],
        },
        {
          key: "min_purchase_value",
          label: "Min Purchase Value",
          type: "number",
          placeholder: "Minimum purchase value",
        },
        {
          key: "max_purchase_value",
          label: "Max Purchase Value",
          type: "number",
          placeholder: "Maximum purchase value",
        },
      ],
    },
    {
      title: "Date Ranges",
      color: "bg-purple-500",
      fields: [
        {
          key: "created_after",
          label: "Created After",
          type: "date",
        },
        {
          key: "created_before",
          label: "Created Before",
          type: "date",
        },
        {
          key: "start_date_after",
          label: "Start Date After",
          type: "date",
        },
        {
          key: "end_date_before",
          label: "End Date Before",
          type: "date",
        },
      ],
    },
  ],
};

export const CATEGORY_FILTER_CONFIG: FilterModalConfig = {
  title: "Filter Categories",
  sections: [
    {
      title: "General Filters",
      color: "bg-blue-500",
      fields: [
        {
          key: "name",
          label: "Category Name",
          type: "string",
          placeholder: "Search by category name",
        },
        {
          key: "created_after",
          label: "Created After",
          type: "date",
        },
        {
          key: "created_before",
          label: "Created Before",
          type: "date",
        },
      ],
    },
  ],
};

export const INVENTORY_FILTER_CONFIG: FilterModalConfig = {
  title: "Filter Inventory",
  sections: [
    {
      title: "Product Information",
      color: "bg-blue-500",
      fields: [
        {
          key: "product_title",
          label: "Product Title",
          type: "string",
          placeholder: "Search by product title",
        },
        {
          key: "status",
          label: "Status",
          type: "select",
          options: [
            { value: "in_stock", label: "In Stock" },
            { value: "out_of_stock", label: "Out of Stock" },
            { value: "low_stock", label: "Low Stock" },
          ],
        },
      ],
    },
    {
      title: "Stock Levels",
      color: "bg-green-500",
      fields: [
        {
          key: "min_inventory",
          label: "Minimum Stock",
          type: "number",
          placeholder: "Min inventory level",
        },
        {
          key: "max_inventory",
          label: "Maximum Stock",
          type: "number",
          placeholder: "Max inventory level",
        },
      ],
    },
  ],
};
